export default "__VITE_ASSET__2Cr$l97d__"